<template>
  <el-row
    type="flex"
    class="industry"
  >
    <div>
      <el-select
        class="first"
        filterable
        clearable
        placeholder="一级行业"
        v-model.trim="parent"
        :disabled="disabled"
        @change="getParent"
      >
        <el-option
          v-for="item in parentList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div>

      <el-select
        class="second"
        filterable
        clearable
        placeholder="二级行业"
        v-model.trim="second"
        @change="getSecond"
        :disabled="disabled"
      >
        <el-option
          v-for="item in secondList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>

    </div>
  </el-row>

</template>

<script>
export default {
  name: "industry",
  props: ["value", "disabled", "requestApi"],
  data() {
    return {
      parentList: [],
      parent: undefined,
      second: undefined,
      secondList: []
    };
  },
  methods: {
    getIndustry(id = 0) {
      return this.requestApi({ parentId: id });
    },
    getParent() {
      this.second = ''
      this.emitVal()
    },
    getSecond() {
      this.emitVal();
    },
    emitVal() {                                                  
      this.$emit("input", [this.parent, this.second]);
      this.$emit("change", [this.parent, this.second]);
    }
  },
  watch: {
    value: {
      handler(val) {
        if (Array.isArray(val)) {
          this.parent = val[0];
          this.second = val[1];
        }
      },
      immediate: true
    },
    parent: {
      handler(val) {
        if (val) {
          this.getIndustry(val).then(val => {
            if (val.data) {
              this.secondList = val.data.data || val.data;
            }
          });
          this.emitVal();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getIndustry().then(val => {
      if (val.data) {
        this.parentList = val.data.data || val.data;
      }
    });
  }
};
</script>

<style lang="scss">
.industry .first.el-select .el-input__inner {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: 0;
}
.industry .second.el-select .el-input__inner {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
</style>
